export const getOriginalFileURLFromCroppedURL = (croppedURL: string): string => {
  if (!croppedURL) return '';

  try {
    const url = new URL(croppedURL);
    // Drop any cache-busting query (?v=…) so the derived original URL is clean.
    url.search = '';
    const key = url.pathname.slice(1);
    const lastSlashIndex = key.lastIndexOf('/');

    if (lastSlashIndex === -1) {
      url.pathname = `/original_${key}`;
      return url.toString();
    }

    const directory = key.slice(0, lastSlashIndex + 1);
    const fileName = key.slice(lastSlashIndex + 1);

    url.pathname = `/${directory}original_${fileName}`;
    return url.toString();
  } catch {
    return croppedURL;
  }
};
